import { GameState } from './types';

interface TutorialStep {
  title: string;
  text: string;
}

const STEPS: TutorialStep[] = [
  {
    title: 'Welcome, Little Robot!',
    text: 'You\'re a friendly robot in a cozy world! Use WASD or Arrow Keys to walk around.',
  },
  {
    title: 'Chop Some Trees!',
    text: 'Walk up to a tree and press SPACE to chop it. Chop 3 times to get wood!',
  },
  {
    title: 'Sell Wood for Coins!',
    text: 'Find the gold Vendor Bot and press F to sell your wood for shiny coins!',
  },
  {
    title: 'Build and Craft!',
    text: 'Press C to craft spears and tools. Press B to build walls and houses!',
  },
  {
    title: 'Defend Your Base!',
    text: 'Silly slimes will try to reach your base. Throw spears with E to boop them away! Upgrade your base to level 5 to win!',
  },
];

export function showTutorial(state: GameState): void {
  if (state.tutorialStep < 1 || state.tutorialStep > STEPS.length) return;

  const overlay = document.getElementById('tutorial');
  const title = document.getElementById('tutorial-title');
  const text = document.getElementById('tutorial-text');

  if (!overlay || !title || !text) return;

  const step = STEPS[state.tutorialStep - 1];
  title.textContent = step.title;
  text.textContent = step.text;
  overlay.classList.remove('hidden');
}

export function initTutorialButtons(state: GameState): void {
  const nextBtn = document.getElementById('tutorial-next');
  const skipBtn = document.getElementById('tutorial-skip');
  const overlay = document.getElementById('tutorial');

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      state.tutorialStep++;
      if (state.tutorialStep > STEPS.length) {
        state.tutorialStep = -1;
        if (overlay) overlay.classList.add('hidden');
      } else {
        showTutorial(state);
      }
    });
  }

  if (skipBtn) {
    skipBtn.addEventListener('click', () => {
      state.tutorialStep = -1;
      if (overlay) overlay.classList.add('hidden');
    });
  }
}
